import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate, AnimationEvent } from '@angular/animations';

@Component({
  selector: 'app-accordion-element-body',
  templateUrl: './accordion-element-body.component.html',
  animations: [
    trigger('toggleAnimation', [
      state('open', style({
        height: '*',
      })),
      state('closed', style({
        height: '0px',
      })),
      transition('open <=> closed', animate('300ms ease-in-out'))
    ])
  ]
})
export class AccordionElementBodyComponent implements OnInit {

  expanded: boolean;

  overflowVisible: boolean;

  constructor() {
  }

  ngOnInit() {
  }

  onAnimationEvent(event: AnimationEvent) {
    this.overflowVisible = event.phaseName === 'done' && event.toState === 'open';
  }

  public setState(expanded: boolean) {
    this.expanded = expanded;
  }

  get overflow(): string {
    return this.overflowVisible ? 'visible' : 'hidden';
  }

}
